export default {
  /*更新用户查看的订单列表*/
  UPDATEORDERLISTS (state, orders) { state.OrderLists = orders;},
  /*更新酒店待报价列表*/
  UPDATEQUOTATION (state, orders) { state.QuotationLists = orders; console.log(orders)},
  /*更新订单详情页*/
  UPDATEORDERDETAIL (state, orderDetail) { state.OrderDetail = orderDetail;},
  /*更新业务管理列表*/
  UPDABUSINESSLIST (state, BusinessList) { state.BusinessList = BusinessList;},
  /*更新查询到的订单总数*/
  UPDATEORDERTOTAL (state, total) { state.TotalOrder = total; },
  /*旗下人员*/
  UPDATEORDERUSERLIST (state, total) { 
    state.Userlist = total; 
  },
  /*旗下酒店*/
  UPDATEORDERHOTELLIST (state, total) { state.Hotellist = total; },
  /*更新酒店报价列表*/
  UPDATEOFFERLISTS (state, offerLists) { state.HotterOfferLists = offerLists; },
  /*已完成订单未选中酒店 */
  UPDATENOCHOOSE (state, nochoose) { state.noChoose = nochoose },
  /*被选中酒店 */
  UPDATECHOOSE (state, choose) { state.choose = choose },
  /*更新采购商购物车内的酒店*/
  UPDATEHOTELSHOPCAR (state, hotelArr) { state.travelChoose = hotelArr },
  /*更新发布订单时的订单信息*/
  UPDATEORDERPOSTPRE (state, orderInfo) { state.orderPostPre = orderInfo },
  /*更新匹配订单的匹配结果*/
  UPDATEMATCHRESULT (state,resultInfo) { state.orderMatchResult = resultInfo },
  /*更新年卡信息*/
  UPDATECARDINFO (state,infoList) { state.CardInfoList = infoList },
  /*更新各门店的待处理及相应状态的订单总数*/
  UPDATEORDERNUMINFO (state,numInfo) { state.OrderNumInfo = numInfo; console.log(numInfo)},
  /*更新询价清单*/
  UPDATEINQUIRYLISTINFO (state,{infoList,modify}) {
    console.log(infoList,modify); 
    let  list = state.inquiryList;
    if(modify=='add'){ list=[...list, infoList]};
    if(modify=='deletes'){
            list = list.filter(res => res.id !== infoList.id);
    };
    //清空询价
    if(modify=='clear'){
      list=[];
    }
    //储存到本地
    localStorage.setItem('inquiryList',JSON.stringify(list));
    state.inquiryList = list;
  },
  /******************修改订单状态*******************/
  /*更新修改时房间列表信息*/
  UPDATEROOMLIST (state, roomList) { state.StoreRoomList = roomList; },
  /*更新修改时会议室列表信息*/
  UPDATEMEETINGLIST (state, meetList) { state.StoreMeetList = meetList; },
}
